import { Accordion, AccordionItem } from "@nextui-org/accordion";
import { ChevronDown, ChevronLeft, ChevronRight } from "lucide-react";
import { memo, ReactNode } from "react";
import { cn } from "../../utils/cn";
import { useTranslation } from "react-i18next";

interface AccordianProps {
  title?: ReactNode;
  children: ReactNode;
  id?: string;
  selectedKey?: string;
  onSelectionChange?: (id: string) => void;
  chevronStyle?: string;
  itemStyle?: string;
}

const Accordian = ({
  title,
  children,
  id = "1",
  selectedKey = "1",
  onSelectionChange,
  chevronStyle,
  itemStyle = "-m-2",
}: AccordianProps) => {
  const { i18n } = useTranslation();

  const isOpen = selectedKey === id;

  return (
    <Accordion
      selectedKeys={isOpen ? new Set([id]) : new Set()}
      onSelectionChange={() => id && onSelectionChange?.(isOpen ? "" : id)}
    >
      <AccordionItem
        key={id}
        className={itemStyle}
        indicator={({ isOpen }) =>
          isOpen ? (
            <ChevronDown className={cn("-mt-2", chevronStyle)} />
          ) : i18n.language === "en" ? (
            <ChevronLeft className={cn("-mt-2", chevronStyle)} />
          ) : (
            <ChevronRight className={cn("-mt-2", chevronStyle)} />
          )
        }
        title={title}
      >
        {children}
      </AccordionItem>
    </Accordion>
  );
};

export default memo(Accordian);
